import dayjs, { Dayjs } from "dayjs"

export type VietnamHoliday = {
  date: string
  nameKey: "holiday_new_year" | "holiday_tet" | "holiday_hung_kings" | "holiday_liberation" | "holiday_labor" | "holiday_national"
}

/** Mùng 1 Tết (dương lịch) — đủ xa cho lịch đặt vé. */
const TET_MUNG_1: Record<number, string> = {
  2025: "2025-01-29",
  2026: "2026-02-17",
  2027: "2027-02-06",
  2028: "2028-01-26",
  2029: "2029-02-13",
  2030: "2030-02-03",
  2031: "2031-01-23",
}

/** Giỗ Tổ Hùng Vương (10/3 âm) theo dương lịch. */
const HUNG_KINGS: Record<number, string> = {
  2025: "2025-04-07",
  2026: "2026-04-26",
  2027: "2027-04-16",
  2028: "2028-04-04",
  2029: "2029-04-23",
  2030: "2030-04-12",
  2031: "2031-04-01",
}

const holiday = (date: string, nameKey: VietnamHoliday["nameKey"]): VietnamHoliday => ({
  date,
  nameKey,
})

export const getVietnamHolidaysForYear = (year: number): VietnamHoliday[] => {
  const items: VietnamHoliday[] = [
    holiday(`${year}-01-01`, "holiday_new_year"),
    holiday(`${year}-04-30`, "holiday_liberation"),
    holiday(`${year}-05-01`, "holiday_labor"),
    holiday(`${year}-09-01`, "holiday_national"),
    holiday(`${year}-09-02`, "holiday_national"),
  ]

  const tetStart = TET_MUNG_1[year]
  if (tetStart) {
    const mung1 = dayjs(tetStart)
    // Bộ luật Lao động: 5 ngày Tết (30 Tết + mùng 1–4)
    items.push(
      holiday(mung1.subtract(1, "day").format("YYYY-MM-DD"), "holiday_tet"),
      holiday(mung1.format("YYYY-MM-DD"), "holiday_tet"),
      holiday(mung1.add(1, "day").format("YYYY-MM-DD"), "holiday_tet"),
      holiday(mung1.add(2, "day").format("YYYY-MM-DD"), "holiday_tet"),
      holiday(mung1.add(3, "day").format("YYYY-MM-DD"), "holiday_tet"),
    )
  }

  const hungKings = HUNG_KINGS[year]
  if (hungKings) {
    items.push(holiday(hungKings, "holiday_hung_kings"))
  }

  return items
}

export const getVietnamHolidaysInMonth = (month: Dayjs): VietnamHoliday[] => {
  const prefix = month.format("YYYY-MM")
  return getVietnamHolidaysForYear(month.year())
    .filter((item) => item.date.startsWith(prefix))
    .sort((a, b) => a.date.localeCompare(b.date))
}

export const getVietnamHolidayMap = (months: Dayjs[]): Record<string, VietnamHoliday> => {
  const years = new Set(months.map((month) => month.year()))
  const map: Record<string, VietnamHoliday> = {}
  years.forEach((year) => {
    getVietnamHolidaysForYear(year).forEach((item) => {
      map[item.date] = item
    })
  })
  return map
}
